import moment from 'moment';
import i18n from 'invision-core/src/components/i18n/i18n';
import { getInjector, getUiNotificationService } from 'invision-core/src/components/injectables/injector.helper';
import { ASYNC_STATUS_CONSTANTS } from '../constants/wizard.constants';
import CustomerCareKeys from '../../locales/keys';
import { RETRIEVE_ORDER_QUOTE_COUNTDOWN_DURATION } from '../../customercare.constants';

/**
 * Returns the difference in seconds from the passed in timestamp or will return 0 if negative.
 * @param {moment.Moment} retrieveOrderQuoteTimestamp
 * @return {number}
 */
export var getRetrieveOrderQuoteCountdown = function getRetrieveOrderQuoteCountdown(retrieveOrderQuoteTimestamp) {
  var retrieveQuoteTimestamp = retrieveOrderQuoteTimestamp.diff(moment.now(), 'seconds') || 0;
  return retrieveQuoteTimestamp > 0 ? retrieveQuoteTimestamp : 0;
};

/**
 * Used to see if async should repeat or handle any errors and make the interval stop.
 * @param {function} onRefreshQuote
 * @param {function} isIntervalContinuing
 */
export var asyncRepeatInterval = function asyncRepeatInterval(onRefreshQuote, isIntervalContinuing) {
  onRefreshQuote();
  var $interval = getInjector().get('$interval');
  var interval = $interval(function () {
    if (isIntervalContinuing()) {
      onRefreshQuote().then(function (response) {
        if (response.Status === ASYNC_STATUS_CONSTANTS.FAILED) {
          getUiNotificationService.transientError(i18n.translate(CustomerCareKeys.CART_SUMMARY.QUOTE_ERROR));
          $interval.cancel(interval);
        } else if (response.Status === ASYNC_STATUS_CONSTANTS.COMPLETE) {
          $interval.cancel(interval);
        }
      }).catch(function () {
        $interval.cancel(interval);
      });
    } else {
      $interval.cancel(interval);
    }
  }, RETRIEVE_ORDER_QUOTE_COUNTDOWN_DURATION);
};